import { FeatureFlag } from 'src/shared/constants';
import { isServer as _isServer } from 'src/shared/helpers/environment';

const getMobileExperimentFactory = (isServer: () => boolean) => (
  experiment: FeatureFlag.Mobile,
) =>
  !isServer() &&
  window.HOVERApp?.experiments &&
  window.HOVERApp?.experiments[experiment];
const getMobileExperiment = getMobileExperimentFactory(_isServer);

export { getMobileExperimentFactory, getMobileExperiment };
